import type { IconProps } from '../types/IconProps.ts';
export const ClockArrowLeft: IconProps = {
    name: 'ClockArrowLeft',
    children: [
        `<path d="M22 12a10 10 0 1 0-10 10" />`,
        `<path d="m18 13-3.91 3.9c-.12.05-.12.15 0 .2L18 21M15 17h7M12 6v5l1 1" />`,
    ]
};